// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__2DtQH","row":"Node_row__3ls3x","label":"Node_label__3QQcR","footer":"Node_footer__3AcWy"};